import type { FC } from 'react';

const NotFound: FC = () => {
  return (
    <>
      <h1>-404- Page Not Found</h1>
    </>
  );
};

export default NotFound;
